import { render, staticRenderFns } from "./ReferencePage.vue?vue&type=template&id=7aa5f96d&scoped=true&"
import script from "./ReferencePage.vue?vue&type=script&lang=js&"
export * from "./ReferencePage.vue?vue&type=script&lang=js&"
import style0 from "./ReferencePage.vue?vue&type=style&index=0&id=7aa5f96d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa5f96d",
  null
  
)

export default component.exports